import { render, staticRenderFns } from "./TouchCard.vue?vue&type=template&id=4292939e&scoped=true"
import script from "./TouchCard.vue?vue&type=script&lang=js"
export * from "./TouchCard.vue?vue&type=script&lang=js"
import style0 from "./TouchCard.vue?vue&type=style&index=0&id=4292939e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4292939e",
  null
  
)

export default component.exports